exports.name = 'IHOsakaSueki';


// WEBPACK FOOTER //
// ./map/js/ih_class_name.js